export default "__VITE_ASSET__RYmuH5tt__"